import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import config from '../../../config/config';
import {getLoginUrl, hasSession} from '../../../utils/auth';

const LoginToApply = ({nextPage}) => {

  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    hasSession()
      .then(session => {
        setLoading(false);
        setAuthenticated(!!session);
      })
      .catch((e) => {
        console.error('Failed to retrieve session: ', e);
        setLoading(false);
        setAuthenticated(false);
      });
  });

  if (loading) {
    return null;
  }

  if (authenticated) {
    return (
      <Button
        variant="contained"
        color="primary"
        component={Link}
        to={nextPage}>
        Apply
      </Button>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs="auto">
        <Button
          variant="contained"
          color="primary"
          component="a"
          href={getLoginUrl(config)(nextPage)}>
          Log in
        </Button>
      </Grid>
      <Grid item xs="auto">
        <Button
          variant="contained"
          color="secondary"
          component="a"
          href={getLoginUrl(config)(nextPage) + '&prompt=create'}>
          Register
        </Button>
      </Grid>
    </Grid>
  );
};

LoginToApply.propTypes = {
  nextPage: PropTypes.string.isRequired,
};

export default LoginToApply;
